import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_2 = { class: "col-lg-12 pe-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-800 text-hover-primary mt-7" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Pegawai PSM Jabatan")
], -1)
const _hoisted_4 = { class: "mb-2 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required form-label"
}, "Kementerian", -1)
const _hoisted_6 = { class: "mb-2 fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required form-label"
}, "Jabatan", -1)
const _hoisted_8 = { class: "mb-2 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required form-label"
}, "Agensi/Negeri/Cawangan", -1)
const _hoisted_10 = { class: "mb-2 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required form-label"
}, "Senarai Pegawai PSM", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_VueSelect, {
          class: "form-control",
          modelValue: _ctx.form.kementerian,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.kementerian) = $event)),
          label: "nama_kementerian",
          options: _ctx.optKementerian
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_VueSelect, {
          class: "form-control",
          modelValue: _ctx.form.jabatan,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.jabatan) = $event)),
          label: "nama_jabatan",
          options: _ctx.optJabatanFiltered
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_VueSelect, {
          class: "form-control",
          modelValue: _ctx.form.bahagian,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.bahagian) = $event)),
          label: "nama_bahagian",
          options: _ctx.optBahagianFiltered
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("i", {
          onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPSMNotFound = true)),
          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPSMNotFound = false)),
          class: "fas fa-exclamation-circle ms-2 fs-7",
          "data-bs-toggle": "tooltip",
          ref: "tooltipIcon",
          style: {"cursor":"pointer"}
        }, null, 544),
        _createElementVNode("div", {
          class: "alert alert-primary",
          role: "alert",
          style: _normalizeStyle(_ctx.stylePSMNotFound)
        }, [
          _createTextVNode(" Sekiranya Pegawai PSM anda tiada dalam senarai di bawah,"),
          _hoisted_12,
          _createTextVNode("sila hubungi talian meja bantuan. ")
        ], 4),
        _createVNode(_component_VueSelect, {
          class: "form-control",
          modelValue: _ctx.form.psmMaklumat,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.psmMaklumat) = $event)),
          label: "nama_penuh",
          options: _ctx.optPsmMaklumat
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}